import EntityStatusBadge from '#/modules/commonComponents/table/EntityStatusBadge';

/** SideMsg `value` 回呼：狀態欄顯示 badge。 */
export function entityStatusSideMsgValue(row) {
  return <EntityStatusBadge status={row?.status} />;
}

/** Table 置中包裝。 */
export function renderEntityStatusBadge(status) {
  return (
    <span className="flex justify-center">
      <EntityStatusBadge status={status} />
    </span>
  );
}
